<template>
  <div class="base">
    <div class="hero-container">
      <div class="hero-container-left">
        <h1 class="hero-container-left-h1">
          Keep learning and,
          <!-- 《地面理论与航空系统工程》 -->
          <br />
          keep enthusiasm.
          <!-- &emsp;&emsp;&emsp;题库管理系统 -->
        </h1>
        
        <p class="hero-container-left-p">
          
          Proficient in Pilot's Handbook 
          <br />
          of Aeronautical Knowledge,or grounded.
        </p>
        
        <div class="hero-container-left-button">
          <el-button class="hero-container-left-button-left" @click="goLogin">
            <div class="hero-container-left-button-left-subtext">我是学生</div>

            <br />
            <div class="hero-container-left-button-left-content">
              <div class="hero-container-left-button-left-content-text">
                学生登录
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-button>
          <el-button class="hero-container-left-button-right" @click="goLogin">
            <div class="hero-container-left-button-right-subtext">我是教师</div>

            <br />
            <div class="hero-container-left-button-right-content">
              <div class="hero-container-left-button-right-content-text">
                教师登录
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-button>
        </div>
      </div>
      <div class="hero-container-right" style="max-width: 50%">
        <el-image
          style="width: 542px; height: 408px"
          :src="require('../assets/mainPic2222.png')"
          fit="cover"
        >
        </el-image>
      </div>
    </div>

    <div class="home-card">
      <div class="home-card-container">
        <!-- <el-carousel type="card" height="200px">
          
          <el-carousel-item >
            
            <h3 class="medium">题目管理</h3>
            <div>
              <el-tag @click.native="goInsertQuestion">上传题目</el-tag>
              <el-tag @click.native="goUpdateQuestion">编辑题目</el-tag>
              
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <h3 class="medium">题库练习</h3>
            <div>
              <el-tag @click.native="goExerciseSequence">顺序练习</el-tag>
              
              
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <h3 class="medium">在线考试</h3>
          </el-carousel-item>
          <el-carousel-item >
            <h3 class="medium">学生管理</h3>
          </el-carousel-item>
        </el-carousel> -->

        <el-row
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 100%;
            /* flex-wrap: wrap; */
          "
        >
          <el-col
            :span="8"
            v-for="(item, index) in cardList"
            :key="item"
            :offset="index > 0 ? 2 : 0"
            style="width: auto"
          >
            <el-card :body-style="{ padding: '0px' }">
              <div class="container">
                <div class="item">
                  <el-image :src="item.imgSrc" class="image" fit="contain" />
                </div>
                <div class="caption">
                  <el-button
                    v-for="(buttonItem, index) in item.functionList"
                    round
                    type="primary"
                    plain
                    @click="runBtnEvent(buttonItem)"
                    >{{ buttonItem.name }}
                  </el-button>
                </div>
              </div>

              <div style="" class="moduleName">
                <span>{{ item.moduleName }}</span>
                <!-- <div class="bottom clearfix">
                  
                  <el-button type="text" class="button">操作按钮</el-button>
                </div> -->
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ball from './other/ball.vue';
export default {
  components: { ball },
  name: "Main",
  data() {
    return {
      cardList: [
        {
          imgSrc: require("../assets/plane.png"),
          moduleName: "题目管理",
          functionList: [
            {
              name: "上传题目",
              src: "/question/insert",
              clickName: "this.goInsertQuestion()",
              authorityRequire: false,
            },
            {
              name: "编辑题目",
              src: "/question/edit",
              clickName: "this.goUpdateQuestion()",
              authorityRequire: false,
            },
            {
              name: "审核题目",
              src: "/question/verify",
              clickName: "this.goVerifyQuestion()",
              authorityRequire: true,
            },
          ],
        },
        {
          imgSrc: require("../assets/aircraft3.png"),
          moduleName: "题库练习",
          functionList: [
            {
              name: "顺序练习",
              src: "/exercise/sequential",
              clickName: "this.goExerciseSequence()",
              authorityRequire: false,
            },
            {
              name: "错题练习",
              src: "/exercise/wrong",
              clickName: "this.goWrongExercise()",
              authorityRequire: false,
            },
            {
              name: "收藏题练习",
              src: "/exercise/favourite",
              clickName: "this.goFavExercise()",
              authorityRequire: false,
            },
            // {
            //   name: "智能练习",
            //   src: "/exercise/sequential",
            //   clickName: "this.goAIExercise()",
            //   authorityRequire: false,
            // },
          ],
        },
        {
          imgSrc: require("../assets/aircraft2.png"),
          moduleName: "在线考试",
          functionList: [
            {
              name: "模拟考试",
              src: "/exam/online",
              clickName: "this.goOnlineExam()",
              authorityRequire: false,
            },
            {
              name: "查看历史考试",
              src: "/exam/list",
              clickName: "this.goListExam()",
              authorityRequire: false,
            },
            {
              name: "教师组卷",
              src: "/exam/online",
              clickName: "this.goMakeUpExam()",
              authorityRequire: true,
            },
          ],
        },
        {
          imgSrc: require("../assets/aircraft4.png"),
          moduleName: "学生管理",
          functionList: [
            {
              name: "学生管理",
              src: "/student/manage",
              clickName: "this.goManageStudent()",
              authorityRequire: true,
            },
            {
              name: "翻转课堂",
              src: "/student/export",
              clickName: "this.goScoreExport()",
              authorityRequire: true,
            },
          ],
        },
      ],
    };
  },
  computed: {},
  methods: {
    runBtnEvent(btn) {
      if (this.$store.state.user.isLogin) {
        if (btn.authorityRequire == true &&  this.$store.state.user.role == 1) {
          this.$notify.error({
            title: "权限限制",
            message: "尚未对学生开放此功能模块",
          });
        } else {
          eval(btn.clickName);
        }
      } else {
        this.$notify.error({
          title: "未登录",
          message: "未进行身份验证",
        });
      }
    },
    goLogin() {
      if (this.$store.state.user.isLogin == true) {
        this.$confirm("您已登录，是否退出登录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.commit("savaIsLogin", false);
            this.$router.push("/login");
          })
          .catch(() => {});
      } else {
        this.$router.push("/login");
      }
    },
    //
    goInsertQuestion() {
      this.$router.push("/question/insert");
    },
    goUpdateQuestion() {
      this.$router.push("/question/edit");
    },
    goVerifyQuestion() {
      this.$router.push("/question/verify");
      this.$store.commit("changeExerciseIndex", 4);
    },
    //
    goExerciseSequence() {
      this.$router.push("/exercise/sequential");
      this.$store.commit("changeExerciseIndex", 1);
    },
    goWrongExercise() {
      this.$router.push("/exercise/wrong");
      this.$store.commit("changeExerciseIndex", 2);
    },
    goAIExercise() {
      this.$notify.info({
        title: "题目数据量不足",
        message: "做题数据不足，无法进入智能练习",
      });
      // this.$router.push("/ai/exercise");
      // this.$store.commit("changeExerciseIndex", 3);
    },
    goFavExercise() {
      this.$router.push("/exercise/favourite");
      this.$store.commit("changeExerciseIndex", 8);
    },

    goOnlineExam() {
      this.$confirm(
        `<span>考试范围：全部题目</span>
      <br></br>
      <span>考试时间：120分钟</span>
      <br></br>
      <span>考试满分：100分</span>
      <br></br>
      <span>题目总数：100题</span>
      <br></br>
      <span>备注：按照各章节现有题目比例随机抽题,若上次考试未完成，本次将继续上一次考试</span>
       `,
        "模拟考试",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "开始考试",
          cancelButtonText: "取消",
          type: "none",
        }
      )
        .then(() => {
          this.$store.commit("changeExerciseIndex", 5);
          this.$router.push("/exam/online");
        })
        .catch(() => {});
    },
    goListExam() {
      this.$router.push("/exam/list");
      this.$store.commit("changeExerciseIndex", 6);
    },
    goMakeUpExam() {
      // this.$notify.info({
      //   title: "开发中",
      //   message: "此功能仍在开发",
      // });

      this.$router.push("/exam/export");
      this.$store.commit("changeExerciseIndex", 7);
    },
    //
    goManageStudent() {
      this.$router.push("/student/manage");
    },
    goScoreExport() {
      this.$router.push("/student/export");
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");
@import url("http://fonts.useso.com/css?family=Quicksand");



.base {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  user-select: none;
  .hero-container {
    z-index: 0;
    background-color: rgb(255, 255, 255);
    flex-flow: row;
    justify-content: center;
    align-items: center;
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    display: flex;
    // width: 70%;
    width: 100%;
    // margin-top: 50px;
    .hero-container-left {
      .hero-container-left-h1 {
        font-size: 62px;//原来尺寸
        //font-size: 54px;//答辩时中文字尺寸
        color: var(--black);
        text-align: left;
        justify-content: center;
        align-self: auto;
        align-items: flex-start;
        margin-top: 0;
        margin-bottom: 24px;
        font-family: Poppins, sans-serif;
        margin: 0.67em 0;
        font-weight: 700;
        line-height: 68px;
        display: block;
      }
      .hero-container-left-p {
        color: var(--black);
        text-align: left;
        justify-content: center;
        align-items: flex-start;
        margin: 0;
        padding: 0;
        font-family: Poppins, sans-serif;
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        display: block;
      }
      .hero-container-left-button {
        align-self: flex-start;
        flex-wrap: wrap;
        flex: 1;
        align-content: center;
        margin-top: 32px;
        display: flex;
        grid-column-gap: 16px;
        justify-content: flex-start;
        align-items: center;
        color: var(--black);
        font-family: Poppins, sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 120%;
        .hero-container-left-button-left {
          height: 65px;

          flex-direction: column;

          min-width: 200px;
          grid-row-gap: 6px;
          color: #fff;
          background-color: #8854c0;
          border-radius: 8px;
          flex-flow: column;

          flex: 0 auto;
          align-content: center;
          justify-content: center;
          align-self: flex-start;
          align-items: flex-start;
          padding: 16px 20px;
          text-decoration: none;
          transition: all 0.3s ease-in-out;
          display: flex;
          box-shadow: 0 4px #6c4298;
          &:hover {
            box-shadow: 0 4px #ffffff;
            transform: translateY(4px);
          }

          .hero-container-left-button-left-subtext {
            opacity: 0.6;
            letter-spacing: 1.2px;
            text-transform: uppercase;
            align-self: flex-start;
            font-family: Poppins, sans-serif;
            font-size: 12px;
            font-weight: 600;
            line-height: 100%;
            transform: translate(-21px, 8px);
          }
          .hero-container-left-button-left-content {
            width: 100%;
            grid-column-gap: 10px;
            color: var(--purple);
            flex-flow: row;
            align-content: stretch;
            justify-content: flex-start;
            align-items: center;
            display: flex;
            .hero-container-left-button-left-content-text {
              font-size: 18px;
              color: var(--white);
              text-align: left;
              font-family: Poppins, sans-serif;

              font-weight: 600;
              line-height: 100%;
            }
            .el-icon-arrow-right {
            }
          }
        }
        .hero-container-left-button-right {
          height: 65px;
          min-width: 200px;
          grid-row-gap: 6px;
          color: #5d2057;
          background-color: #f2f2f2;
          border-radius: 8px;
          flex-flow: column;

          flex: 0 auto;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          align-self: flex-start;
          align-items: flex-start;
          // justify-content: space-around;
          // align-items: flex-start;
          padding: 16px 20px;
          text-decoration: none;
          transition: all 0.3s ease-in-out;
          display: flex;
          box-shadow: 0 4px #ccc;
          font-family: Quicksand, sans-serif;
          font-size: 16px;
          font-weight: 500;
          &:hover {
            box-shadow: 0 4px #ffffff;
            transform: translateY(4px);
          }
          .hero-container-left-button-right-subtext {
            opacity: 0.6;
            letter-spacing: 1.2px;
            text-transform: uppercase;
            align-self: flex-start;
            font-family: Poppins, sans-serif;
            font-size: 12px;
            font-weight: 600;
            line-height: 100%;
            transform: translate(-21px, 8px);
          }
          .hero-container-left-button-right-content {
            width: 100%;
            grid-column-gap: 10px;
            color: var(--purple);
            flex-flow: row;
            align-content: stretch;
            justify-content: flex-start;
            align-items: center;
            display: flex;
            .hero-container-left-button-right-content-text {
              font-size: 18px;
              text-align: left;
              font-family: Quicksand, sans-serif;

              font-weight: 600;
              line-height: 100%;
            }
          }
        }
      }
    }
  }
  .home-card {
    // width: 70%;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    .home-card-container {
      width: 100%;
      margin-top: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .container {
        max-width: 100vw;
        display: flex;

        flex-wrap: wrap;

        &:hover {
          .item .image {
            transform: rotateY(-90deg);
            opacity: 0;
          }
          .caption {
            transform: rotateY(0deg);
            opacity: 1;
          }
        }
        .item {
          position: relative;
          width: 235px;
          height: 230px;
          // border: 1px solid red;
          // margin: 15px;
          perspective: 600px;

          .image {
            position: absolute;
            transform-origin: right;
            transform: rotateY(0deg);
            opacity: 1;
            transition: 0.5s;
          }
        }
        .caption {
     
          border-radius: 8px;
          position: absolute;
          z-index: 0;
          background-color: #f5f5f5;
          color: #ffffff;
          width: 100%;
          height: 100%;
          width: 235px;
          height: 230px;
          padding: 30px 30px;
          box-sizing: border-box;
          letter-spacing: 2px;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          transform-origin: left;
          transform: rotateY(90deg);
          opacity: 0;
          transition: 0.5s;
          .el-button {
            margin-left: 10px;
            margin-right: 10px;
            font-size: 16px;
          }
         
        }
      }
      .moduleName {
        padding: 14px;
        text-align: center;
        margin-top: 5px;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 1.5px;
      }
      /*
      .el-carousel{
        
        
        .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
        
       
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
        
        
      }
     
      }
      */
    }
  }
}
</style>